const DEFAULT_KEY = 'theme';
export const getStoredTheme = (key = DEFAULT_KEY) => {
    try {
        const v = localStorage.getItem(key);
        return v === 'light' || v === 'dark' || v === 'system' ? v : null;
    }
    catch {
        return null;
    }
};
const setStoredTheme = (mode, key = DEFAULT_KEY) => {
    try {
        if (mode)
            localStorage.setItem(key, mode);
        else
            localStorage.removeItem(key);
    }
    catch { }
};
export const isSystemDark = () => typeof matchMedia !== 'undefined' && matchMedia('(prefers-color-scheme: dark)').matches;
const applyThemeClass = (mode, root = document.documentElement) => {
    const dark = mode === 'dark' || (mode === 'system' && isSystemDark());
    root.classList.toggle('dark', dark);
    return dark;
};
export const setTheme = (mode, opts) => {
    const key = opts?.storageKey ?? DEFAULT_KEY;
    const root = opts?.root ?? document.documentElement;
    setStoredTheme(mode, key);
    return applyThemeClass(mode, root);
};
export const toggleTheme = (opts) => {
    const key = opts?.storageKey ?? DEFAULT_KEY;
    const current = getStoredTheme(key) ?? 'system';
    const next = current === 'dark' ? 'light' : 'dark';
    return setTheme(next, { storageKey: key, root: opts?.root });
};
